// extracted by css-extract-rspack-plugin
export default {"fishbowl-wrapper":"fishbowl-wrapper-sTeeVG","fishbowlWrapper":"fishbowl-wrapper-sTeeVG"};